import { capitalCase } from 'change-case';

import RouteLink, { RouteLinkProps } from '@/components/RouteLink';
import { RegistryPackage } from '@/graphql/upbound-graphql';

const PackageListLink: React.FC<RouteLinkProps & { data: RegistryPackage }> = ({ data, ...props }) => {
  return (
    <RouteLink
      to="packageList"
      params={{ packageType: data.packageType }}
      display="block"
      color="purple.0"
      prefetch={false}
      _hover={{ textDecoration: 'underline' }}
      fontSize="14px"
      lineHeight="40px"
      {...props}
    >
      {capitalCase(`${data.packageType}S`)}
    </RouteLink>
  );
};

export default PackageListLink;
